import { useEffect } from 'react';
import { hasRole } from '@lb-classroom/feature-auth';

interface UseTutorListGuardParams {
  currentUser: any;
  flashActions: {
    addMessage: (message: string, options?: Record<string, unknown>) => void;
    clearMessage: () => void;
  };
  setState: React.Dispatch<React.SetStateAction<any>>;
}

export const useTutorListGuard = ({
  currentUser,
  flashActions,
  setState,
}: UseTutorListGuardParams) => {
  useEffect(() => {
    if (!currentUser) {
      return () => flashActions.clearMessage();
    }

    const studentProfile = currentUser.student_profile;
    if (!studentProfile) {
      if (hasRole(currentUser.profile_type, 'Tutor')) {
        flashActions.addMessage(
          'This page is restricted for tutors. Please log out to access this page.',
          {
            type: 'error',
            sticky: true,
            autoDisappear: true,
          },
        );
      }
      return () => flashActions.clearMessage();
    }

    if (!studentProfile.is_trial && studentProfile.default_duration === 1) {
      setState((prevState) => ({
        ...prevState,
        chosenDuration: 1,
      }));
    }

    return () => flashActions.clearMessage();
  }, [currentUser, flashActions, setState]);
};
